export enum ReportType {
    All = "ALL",
    Match = "RETAIL_MATCH",
    Mobilytics = "MOBILYTICS",
};